const categories = {
  'weight-loss': 'Weight loss',
  'high-protein': 'High protein',
  keto: 'Keto',
  exercising: 'Exercising',
  'muscle-building': 'Muscle building',
  'weight-gain': 'Weight gain',
  wellness: 'Wellness',
}

export default categories

export const categoriesRegExp = Object.keys(categories).join('|')
